export interface INavigationRoute {
  name: string
  displayName: string
  meta: { icon: string; roles?: string[] }
  children?: INavigationRoute[]
}

export default {
  root: {
    name: '/',
    displayName: 'navigationRoutes.home',
  },
  routes: [
    {
      name: 'dashboard',
      displayName: 'menu.dashboard',
      meta: {
        icon: 'dashboard',
      },
    },
    {
      name: 'chat',
      displayName: 'menu.chat',
      meta: {
        icon: 'chat',
      },
    },
    {
      name: 'contact',
      displayName: 'menu.contact',
      meta: {
        icon: 'contacts',
      },
    },
    {
      name: 'contact-merge',
      displayName: 'menu.mergeContacts',
      meta: {
        icon: 'merge_type',
        roles: ['Admin'],
      },
    },
    {
      name: 'snap',
      displayName: 'menu.snap',
      meta: {
        icon: 'bookmark',
      },
    },
    {
      name: 'channel',
      displayName: 'menu.channel',
      meta: {
        icon: 'link',
        roles: ['Admin'],
      },
    },
    {
      name: 'whatsapp-templates',
      displayName: 'menu.whatsappTemplates',
      meta: {
        icon: 'chat_bubble_outline',
        roles: ['Admin'],
      },
    },
    {
      name: 'broadcast-jobs',
      displayName: 'menu.broadcastJobs',
      meta: {
        icon: 'campaign',
        roles: ['Admin'],
      },
    },

    {
      name: 'reports',
      displayName: 'menu.reports',
      meta: {
        icon: 'assessment',
        roles: ['Admin'],
      },
      children: [
        {
          name: 'contact-report',
          displayName: 'menu.contactReport',
          meta: {
            icon: 'analytics',
            roles: ['Admin'],
          },
        },
        {
          name: 'agent-report',
          displayName: 'menu.agentReport',
          meta: {
            icon: 'schedule',
            roles: ['Admin'],
          },
        },
        {
          name: 'response-time-report',
          displayName: 'menu.responseTimeReport',
          meta: {
            icon: 'access_time',
            roles: ['Admin'],
          },
        },
        {
          name: 'message-report',
          displayName: 'menu.messageReport',
          meta: {
            icon: 'message',
            roles: ['Admin'],
          },
        },
        {
          name: 'heatmap-report',
          displayName: 'menu.heatmapReport',
          meta: {
            icon: 'grid_on',
            roles: ['Admin'],
          },
        },
        {
          name: 'close-reason-report',
          displayName: 'menu.closeReasonReport',
          meta: {
            icon: 'fact_check',
            roles: ['Admin'],
          },
        },
      ],
    },
    {
      name: 'ingest',
      displayName: 'menu.ingest',
      meta: {
        icon: 'cloud_upload',
        roles: ['Admin'],
      },
    },
    {
      name: 'automation',
      displayName: 'menu.automation',
      meta: {
        icon: 'auto_mode',
        roles: ['Admin'],
      },
    },
    {
      name: 'bot-configuration',
      displayName: 'menu.botConfiguration',
      meta: {
        icon: 'smart_toy',
        roles: ['Admin'],
      },
      children: [
        {
          name: 'bot-prompt-configs',
          displayName: 'menu.promptConfigs',
          meta: {
            icon: 'psychology',
            roles: ['Admin'],
          },
        },
        // {
        //   name: 'bot-prompt-variables',
        //   displayName: 'menu.promptVariables',
        //   meta: {
        //     icon: 'data_object',
        //     roles: ['Admin'],
        //   },
        // },
        // {
        //   name: 'bot-pages',
        //   displayName: 'menu.botPages',
        //   meta: {
        //     icon: 'web',
        //     roles: ['Admin'],
        //   },
        // },
      ],
    },
    {
      name: 'agent-management',
      displayName: 'menu.agentManagement',
      meta: {
        icon: 'manage_accounts',
        roles: ['Admin'],
      },
      children: [
        {
          name: 'agent',
          displayName: 'menu.agent',
          meta: {
            icon: 'person',
            roles: ['Admin'],
          },
        },
        {
          name: 'agent-schedule',
          displayName: 'menu.agentSchedule',
          meta: {
            icon: 'schedule',
            roles: ['Admin'],
          },
        },
        {
          name: 'agent-chat-management',
          displayName: 'menu.agentChatManagement',
          meta: {
            icon: 'chat_bubble',
            roles: ['Admin'],
          },
        },
      ],
    },
  ] as INavigationRoute[],
}
